import React from 'react';
import { Pencil, ScanSearch, Loader2 } from 'lucide-react';

/**
 * EmailCategoryFilter - Compact category filter tabs for emails with scan functionality
 */
const EmailCategoryFilter = ({
  categories = [],
  activeCategory,
  onCategoryChange,
  onEditCategories,
  onScanEmails,
  formatCategoryName,
  isScanning = false,
  categoryCounts = {},
  className = ''
}) => {
  return (
    <div className={`flex-shrink-0 px-4 py-3 overflow-x-auto ${className}`}>
      <div className="flex gap-2 items-center">
        <button
          onClick={() => onCategoryChange?.('all')}
          className={`px-4 py-2 rounded-lg text-sm font-semibold transition-all whitespace-nowrap border ${
            activeCategory === 'all'
              ? 'bg-white text-black border-white'
              : 'bg-black text-gray-300 border-gray-400 hover:bg-gray-900 hover:text-white hover:border-gray-300'
          }`}
          data-testid="email-category-all-btn"
        >
          All
        </button>
        {categories.map((cat) => (
          <button
            key={cat}
            onClick={() => onCategoryChange?.(cat)}
            data-testid={`email-category-${cat}-btn`}
            className={`px-4 py-2 rounded-lg text-sm font-semibold transition-all whitespace-nowrap flex items-center gap-1.5 border ${
              activeCategory === cat
                ? 'bg-white text-black border-white'
                : 'bg-black text-gray-300 border-gray-400 hover:bg-gray-900 hover:text-white hover:border-gray-300'
            }`}
          >
            {formatCategoryName ? formatCategoryName(cat) : cat}
            {categoryCounts[cat] > 0 && (
              <span className={`ml-1 px-2 py-0.5 rounded-full text-xs font-bold ${
                activeCategory === cat 
                  ? 'bg-gray-700 text-white' 
                  : 'bg-gray-700 text-gray-300'
              }`}>
                {categoryCounts[cat]}
              </span>
            )}
          </button>
        ))}
        {/* Scan Emails Button */}
        <button
          onClick={onScanEmails}
          disabled={isScanning}
          data-testid="scan-emails-btn"
          className={`px-4 py-2 rounded-lg text-sm font-semibold transition-all whitespace-nowrap flex items-center gap-1.5 border ${
            isScanning 
              ? 'bg-gray-700 text-gray-400 border-gray-500 cursor-not-allowed' 
              : 'bg-black text-white border-gray-400 hover:bg-gray-900 hover:border-gray-300'
          }`}
          title="Re-scan emails and categorize based on current tabs"
        >
          {isScanning ? (
            <>
              <Loader2 size={14} className="animate-spin" />
              Scanning...
            </>
          ) : (
            <>
              <ScanSearch size={14} />
              Scan
            </>
          )}
        </button>
        {/* Edit Categories Button */}
        <button
          onClick={onEditCategories}
          data-testid="edit-email-categories-btn"
          className="px-4 py-2 rounded-lg text-sm font-semibold transition-all whitespace-nowrap bg-black text-gray-300 hover:bg-gray-900 hover:text-white border border-dashed border-gray-400 hover:border-gray-300"
          title="Edit Categories"
        >
          <Pencil size={14} className="inline mr-1" />
          Edit
        </button>
      </div>
    </div>
  );
};

export default EmailCategoryFilter;
